import React from "react";
import Icon3 from "../../assets/images/Services/young-beekeeper-man-clean-wooden-honey-frame-working-apiary-summer-day.jpg";
import "./ServiceSection1.css";
import AboutSectionSubsection1 from "../AboutSection1/AboutSectionSubsection1";
import PollinationServices from "../../assets/images/Services/pollination-service.jpg";
import ContractFarming from "../../assets/images/Services/contract-farming.jpg";
import AdoptColonies from "../../assets/images/Services/adopt-colonies.jpg";
import Monetize from "../../assets/images/Services/manage-eco-bee.jpg";
import ContractManufacturing from "../../assets/images/Services/contract-farming.jpg";

export default function ServiceSection1() {
  const services = [
    {
      image: PollinationServices,
      id: "PollinationServices",
      title: [
        "Pollination Services",
        <p className="d-inline">
          {" "}
          <b>(For Farmers)</b>
        </p>,
      ],
      bodycopy: [
        "ApisChain provides essential pollination services to farmers, helping to enhance the productivity of crops and improve honey production. By ensuring the effective transfer of pollen between plants, ApisChain's services support the health and growth of various agricultural systems, leading to better crop yields and biodiversity. Through their expertise in managing beekeeping operations, ApisChain helps farmers and beekeepers optimize pollination efficiency, promoting sustainable farming practices and boosting the overall quality of agricultural output.",
      ],
    },


    {
      rowreverse: "true",
      image: ContractFarming,
      id: "CFServices",
      title: [
        "Contract Farming Services",
        <p className="d-inline">
          {" "}
          <b>(For Manufacturers)</b>
        </p>,
      ],
      bodycopy:
        "ApisChain's Contract Farming Services for honey establish a direct partnership between beekeepers and honey manufacturers, ensuring a consistent supply of high-quality honey. Through these agreements, ApisChain facilitates clear terms for honey production, including pricing, quality standards, and delivery schedules, benefiting both parties. Beekeepers gain a stable income by adhering to the specifications set by manufacturers, while manufacturers secure a reliable source of honey for their products. This contract farming model helps promote sustainable beekeeping practices and strengthens the honey supply chain.",
    },

    {
      image: AdoptColonies,
      id: "sustainable-asset-management-services",
      title: [
        "Adoptable Eco-Bee Services",
        <p className="d-inline">
          {" "}
          <b>(For Eco-contributor)</b>
        </p>,
      ],
      bodycopy:
        "ApisChain offers Eco-Bees (honeybees) as an adoptable asset opportunity for eco-contributors, allowing them to adopt Eco-Bee. These bees are managed by Eco-entrepreneurs with an expert guidance from ApisChain, ensuring sustainable and productive operations. This integration promotes pollination, honey production, and biodiversity conservation on the farm. ",
    },

    {
      rowreverse: "true",
      image: Monetize,
      id: "profit-generating-services",
      title: [
        "Monetize farming capacity",
        <p className="d-inline">
          {" "}
          <b>(For Eco-entrepreneur)</b>
        </p>,
      ],
      bodycopy:
        "ApisChain offers eco-entrepreneurs a unique service that monetizes farming capacity by managing the Eco-Bees of other investors and eco-contributors. This model allows eco-entrepreneurs to leverage available resources and maximize returns, while ApisChain handles the governance aspects, ensuring sustainable practices, biodiversity, efficiency and profitability. ",
    },

    {
      image: Icon3,
      id: "sustainable-asset-management-services",
      title: [
        "Contract Manufacturing Services",
        <p className="d-inline">
          {" "}
          <b>(For Brands)</b>
        </p>,
      ],
      bodycopy:
        "Contract Manufacturing Services offered by Apischain provide brands with a comprehensive solution for producing high-quality products without the need for large-scale manufacturing infrastructure. By leveraging Apischain's expertise and resources, brands can streamline their production process, reduce operational costs, and maintain flexibility.  ",
    },

    {
      rowreverse: "true",
      image: ContractManufacturing,
      id: "profit-generating-services",
      title: [
        "Colonies Migration Services",
        <p className="d-inline">
          {" "}
          <b>(For Beekeepers)</b>
        </p>,
      ],
      bodycopy:
        "Colonies Migration Services provided by Apischain offer beekeepers a seamless solution for relocating their bee colonies to optimal locations for pollination and honey production. By utilizing Apischain's specialized resources and expertise, beekeepers can ensure the health and productivity of their colonies as they are transported to areas with better access to flowering plants and favorable environmental conditions. This service helps beekeepers maximize their yields, enhance pollination efforts, and maintain the well-being of their colonies, all while reducing the logistical challenges involved in migration.",
    },
  ];
  return (
    <div className="ServiceSectionContainer container ">
      {services.map((e, index) => {
        return (
          <AboutSectionSubsection1
            key={index}
            id={e.id}
            src={e.image}
            bodycopy={e.bodycopy}
            title={e.title}
            rowreverse={e.rowreverse}
          />
        );
      })}
    </div>
  );
}
